import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { TableSettingsModalComponent } from '../table-settings-modal/table-settings-modal.component';

export type TableSettingsEntity = 'salary_table' | 'dashboard';

@Component({
    selector: 'app-table-settings',
    templateUrl: './table-settings.component.html',
    styleUrls: ['./table-settings.component.css']
})
export class TableSettingsComponent implements OnInit, OnDestroy {
    @Input() public entity: TableSettingsEntity;

    @Output() public refreshFn = new EventEmitter<string>();

    public canEditCompanySettings = false;

    public constructor(
        private _authServise: AuthenticationService,
        private _modalService: NgbModal,
    ) { }

    public ngOnDestroy(): void {
    }

    public ngOnInit(): void {
        this.canEditCompanySettings = this._authServise.checkPermission('companySetting.edit');
    }

    public openSettingsModal(): void {
        const modalRef = this._modalService.open(TableSettingsModalComponent, {centered: true});

        modalRef.componentInstance.entity = this.entity;
        modalRef.componentInstance.refreshFn = this.refreshFn;
    }
}
